import React from 'react';
import {Transforms, Path} from 'slate';
import {ReactEditor} from 'slate-react';

export const ActionButtons = ({
  editor,
  element,
  setCroppingImage
}: any): React.JSX.Element => {
  const duplicateNode = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const path = ReactEditor.findPath(editor, element);
      const newElement = JSON.parse(JSON.stringify(element));
      Transforms.insertNodes(editor, newElement, {at: Path.next(path)});
    } catch (error) {
      console.error('Failed to duplicate node:', error);
    }
  };

  const deleteNode = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const path = ReactEditor.findPath(editor, element);
      Transforms.removeNodes(editor, {at: path});
    } catch (error) {
      console.error('Failed to delete node:', error);
    }
  };

  return (
    <div className="element-actions-container" contentEditable={false}>
      {element.type === 'image' && setCroppingImage && (
        <>
          <div
            className="element-action-btn"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (setCroppingImage)
                setCroppingImage({
                  src: element.url,
                  nodePath: ReactEditor.findPath(editor, element)
                });
            }}
            title="Crop Image"
          >
            ✂️
          </div>
          <div className="element-action-divider"></div>
        </>
      )}
      <div
        className="element-action-btn"
        onMouseDown={duplicateNode}
        title="Duplicate"
      >
        ⧉
      </div>
      <div className="element-action-divider"></div>
      <div
        className="element-action-btn delete"
        onMouseDown={deleteNode}
        title="Delete"
      >
        🗑
      </div>
    </div>
  );
};
